import React from "react";
import { RCCGrid, RCCIcon, RCCPopover } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import {formatMinutesInHours} from "src/utils/formartHourMinutes";

export interface IComponentHoursProjectsItem{
    hours: IHoursProjectsItem;
}

export interface IHoursProjectsItem{
    estimated: number;
	foreseen: number;
	real: number;
}

const HoursProjectsItem: React.FC<IComponentHoursProjectsItem> = ({
	hours
}) => {
	const { translate } = useTranslation();

	return(
		<>
			<RCCGrid item>
				<RCCPopover
					color="default"
					header={{
						title:translate("Horas do Projeto")
					}}
					body={{
						custom: (
							<>
								<RCCGrid
									className="popover-body" 
									style={{width:"300px", padding:"10px 10px 10px 50px"}}>
									<RCCGrid 
										item 
										container
										alignItems="center"
										justifyContent="center"
									>
										<RCCGrid container item xs={4}>
											<strong>{translate("Estimada")}</strong>
										</RCCGrid>
										<RCCGrid container item xs={4}>
											<strong>{translate("Prevista")}</strong>
										</RCCGrid>
										<RCCGrid container item xs={4}>
											<strong>{translate("Real")}</strong>
										</RCCGrid>
									
									</RCCGrid>
									<RCCGrid 
										item 
										container
										alignItems="center"
										justifyContent="flex-end"
									>
										<RCCGrid container item xs={4}>
											{formatMinutesInHours(hours.estimated)}
										</RCCGrid>
										<RCCGrid container item xs={4}>
											{formatMinutesInHours(hours.foreseen)}
										</RCCGrid>
										<RCCGrid container item xs={4}>
											{formatMinutesInHours(hours.real)}
										</RCCGrid>
									</RCCGrid>
								</RCCGrid>
							</>
						)
					}}
				>
					<RCCIcon 
						name="clock"
						size={14}
					/>
				</RCCPopover>
			</RCCGrid>
			
		</>
	);
};

export default HoursProjectsItem;
